var map = {
	"./A0.png": 1856,
	"./B0.png": 1857,
	"./BB.png": 1858,
	"./BD.png": 1859,
	"./C0.png": 1860,
	"./D0.png": 1861,
	"./E0.png": 1862,
	"./ecosentino-small.png": 1863,
	"./ecosentino.png": 1864,
	"./icon-dekton.png": 1865,
	"./icon-scalea.png": 1866,
	"./icon-sensa.png": 1867,
	"./icon-silestone.png": 1868,
	"./icon-table.png": 1869,
	"./products/mktools.png": 1870,
	"./sinks.png": 1871
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 808;